import React from "react";
import nutritionImage from "../assets/images/about us.jpeg";
import HeadingText from "./atoms/HeadingText";
import ContentText from "./atoms/ContentText";
import useTranslate from "../hooks/useTranslate";

const MyPersonalStory = () => {
  return (
    <section className=" bg-white py-12">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
        <div className="basis-1/2">
          <HeadingText variant="h2">
            {useTranslate("aboutpage.personalstory.heading")}
          </HeadingText>
          {/* <HeadingText variant="h3">
            Fast forward to today, and I’ve now coached thousands of women
            around the world on health and whole living.
          </HeadingText> */}
          <h3 className="text-2xl font-medium mb-5 font-sans text-primary"></h3>
          <ContentText>
            {useTranslate("aboutpage.personalstory.content.paragraph1")}
          </ContentText>
        </div>
        <div className="basis-1/2 h-full w-full ">
          <img
            src={nutritionImage}
            alt="Nutrition"
            className="object-cover max-h-80 m-auto"
          />
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 mb-6">
        <ContentText>
          {useTranslate("aboutpage.personalstory.content.paragraph2")}
        </ContentText>
      </div>
    </section>
  );
};

export default MyPersonalStory;
